import { CICEnabled } from "./../../interfaces/cic-enabled";
import { SortableCollection } from "./../../collections/sortable-collection";
import { ListTabModel } from "./list-tab";
import {prop} from "../../../decorators/property";

export class CICListTabModel extends ListTabModel {

    @prop() public RelationCollection: SortableCollection<CICEnabled>;

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/tabs/cic-list-tab.ts